import { render } from "./home-latest-users-table.vue?vue&type=template&id=7dac28aa&scoped=true"
import script from "./home-latest-users-table.vue?vue&type=script&lang=js"
export * from "./home-latest-users-table.vue?vue&type=script&lang=js"

import "./home-latest-users-table.vue?vue&type=style&index=0&id=7dac28aa&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dac28aa"]])

export default __exports__